// Wallet pill — chip variant designed for the dark topbar. The
// lighter on-card / on-bar wallet rendering lives in <Address>.
// Both share the 4+4 elision helper at _lib/elide.
// See preview/pills.html (ink-bar row).

import { elideAddress } from './_lib/elide';
import { ConnectionDot } from './ConnectionDot';

export type WalletPillProps = {
  address: `0x${string}`;
  status?: 'connected' | 'disconnected';
};

export function WalletPill({ address, status = 'connected' }: WalletPillProps) {
  return (
    <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-pill text-[11px] border border-border bg-card text-ink whitespace-nowrap">
      <ConnectionDot
        status={status === 'connected' ? 'connected' : 'offline'}
        className="w-1.5 h-1.5"
      />
      <code className="font-mono text-[11px] text-ink">{elideAddress(address)}</code>
    </span>
  );
}
